<template>
  <div
    id="contents"
    class="user-preview"
  >
    <div class="company-area">
      <p
        class="company-name"
        data-test="company-name"
      >
        {{ jobSearchResult.companyName }}
      </p>
      <p
        class="company-title"
        data-test="job-title"
      >
        <a>{{ jobSearchResult.jobTitle }}</a>
        <job-employment-status-sp :employment-status="employmentStatus" />
      </p>
      <div class="company-day">
        <p class="icon">
          <img
            :src="`${userOfferImageUrlForSp}/icon_company_new.png`"
            alt="NEW"
            class="new-icon"
            data-test="new-icon"
          >
          <img
            v-if="jobSearchResult.isSimple && !jobSearchResult.isOriginalEntryForm"
            :src="`${userOfferImageUrlForSp}/icon_company_simple.png`"
            alt="シンプル応募"
            class="simple-interview-icon"
            data-test="simple-icon"
          >
        </p>
      </div>
    </div>
    <div class="contents-inner">
      <p
        class="company-lead"
        data-test="catch-copy"
      >
        <span
          class="pega-pre-wrap job-search-main-title"
          v-text="jobSearchResult.mainTitle"
        />
      </p>
      <div
        v-if="jobSearchResult.mainPhoto && jobSearchResult.isExistsPremiumImage"
        class="company-intro -offer"
      >
        <p>
          <img
            :id="jobSearchResult.mainPhoto.id"
            :src="getPhotoUrl(jobSearchResult.mainPhoto)"
            class="premium-img"
            data-test="premium-photo"
          >
        </p>
      </div>
      <div class="company-intro -offer">
        <div class="text">
          <p class="hd-type-04 m0">
            <span>仕事内容</span>
          </p>
          <p
            class="lead-text mt10"
            data-test="job-content-inner"
          >
            <span
              class="pega-pre-wrap"
              v-text="jobSearchResult.catchCopy"
            />
          </p>
        </div>
        <div
          v-if="jobSearchResult.mainPhoto && !jobSearchResult.isExistsPremiumImage"
          class="photo"
        >
          <p>
            <img
              :id="jobSearchResult.mainPhoto.id"
              :src="getPhotoUrl(jobSearchResult.mainPhoto)"
              class="max-w100"
              data-test="offer-main-image"
            >
          </p>
        </div>
      </div>
      <job-appeal-point-sp
        :pr-codes="prCodes"
        :is-search-result="true"
      />
      <table class="table-type-01">
        <tbody>
          <tr>
            <th class="w25">
              応募資格
            </th>
            <td class="w75">
              <p
                class="text-ellipsis-02"
                data-test="offer-required-inner"
              >
                {{ jobSearchResult.requiredSkill }}
              </p>
            </td>
          </tr>
          <tr>
            <th class="w25">
              給与
            </th>
            <td class="w75">
              <p
                class="text-ellipsis-02"
                data-test="salary-inner"
              >
                {{ jobSearchResult.salary }}
              </p>
            </td>
          </tr>
          <tr>
            <th class="w25">
              勤務地
            </th>
            <td class="w75">
              <p
                class="text-ellipsis-02"
                data-test="place-inner"
              >
                {{ jobSearchResult.place }}
              </p>
            </td>
          </tr>
          <tr>
            <th class="w25">
              PR
            </th>
            <td class="w75">
              <ul class="appeal-point02">
                <li data-test="interview-icon">
                  インタビュー
                </li>
                <li data-test="photo-clip-icon">
                  フォトクリップ
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="!jobSearchResult.isLightPlan && jobSearchResult.report.body"
        class="viewpoint -bg-pink"
      >
        <div class="left">
          <img
            :src="`${userCommonImageUrlForSp}/viewpoints.png`"
            alt="view point"
          >
        </div>
        <div class="right">
          <p data-test="report">
            {{ jobSearchResult.report.body }}
          </p>
        </div>
      </div>
      <div class="col-type-01 mt15">
        <div class="-block w49">
          <a class="link-button review">
            <img
              class="heart"
              :src="`${userCommonImageUrlForSp}/icon_heart_sp.png`"
            >気になる
          </a>
        </div>
        <div class="-block w49">
          <a class="link-button -type02">詳細を見る</a>
        </div>
      </div>
    </div>
    <div class="search-result-border-sp" />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/search/base";
</style>

<script>
import JobAppealPointSp from '@/components/molecules/JobAppealPointSp'
import JobEmploymentStatusSp from '@/components/molecules/JobEmploymentStatusSp'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  components: {
    JobAppealPointSp,
    JobEmploymentStatusSp
  },
  mixins: [jobPreviewCommon],
  props: {
    jobSearchResult: {
      type: Object,
      required: true
    },
    employmentStatus: {
      type: Array,
      default: () => []
    },
    prCodes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
